import styled, { css } from "styled-components";
import { Image as AntImage, Space, Input as AntInput, Row } from "antd";
import { ADMIN_LK } from "@constants";

export const RootContainer = styled.div`
  padding: 0;
  height: calc(100vh - 70px);
  overflow: hidden;
`;

export const EmptyText = styled.div`
  font-size: 13px;
  height: calc(100vh - 461px);
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-height: 800px) {
    height: calc(100vh - 366px);
  }
`;

export const Container = styled.div.attrs({
  id: "scrollableDiv",
})`
  /* padding: 0 5px; */
  /* border: 10px solid green; */
  width: 100%;
  height: calc(100vh - 280px);
  padding-bottom: 12px;
  overflow: auto;
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DateText = styled.div`
  padding: 14px 0;
  font-size: 12px;
  font-weight: normal;
  color: #000000;
  text-align: center;
`;

export const NameText = styled.div`
  padding-right: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #db7802;
  text-align: left;
`;

export const TimeText = styled.div`
  font-size: 10px;
  font-weight: normal;
  color: ${(props) =>
    props.sender === ADMIN_LK ? props.theme.dark3 : props.theme.dark2};
  display: flex;
  justify-content: ${(props) =>
    props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
`;

export const MessageText = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  width: fit-content;
  max-width: 250px;
  padding: 8px 14px;
  border-radius: 12px;

  font-size: 13px;
  font-weight: 500;
  line-height: 25px;
  color: ${(props) =>
    props.sender === ADMIN_LK ? props.theme.textColor : props.theme.white};

  a {
    color: #1677ff !important;

    :active {
      color: #1677ff !important;
    }
  }

  @media screen and (max-width: 480px) {
    width: fit-content;
    max-width: 60vw !important;
  }
`;

export const Item = styled.div`
  padding-bottom: 14px;

  ${MessageWrapper} {
    flex-direction: ${(props) =>
      props.sender === ADMIN_LK ? "row" : "row-reverse"};
  }

  ${MessageText} {
    color: ${(props) => (props.sender === ADMIN_LK ? "#13100F" : "#fff")};
    background: ${(props) =>
      props.sender === ADMIN_LK
        ? "#fff"
        : "linear-gradient(180deg, #181103 0%, #744800 100%)"};
    border-radius: ${(props) =>
      props.sender === ADMIN_LK ? "16px 16px 16px 0px" : "16px 16px 0px 16px"};
  }

  ${ContentWrapper} {
    align-items: ${(props) =>
      props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
  }
`;

export const Image = styled(AntImage).attrs({
  alt: "img",
  preview: { mask: false },
})`
  width: 250px !important;
  aspect-ratio: 1 / 0.7;
  border-radius: 5px;
  object-fit: cover;
  cursor: pointer;

  @media screen and (max-width: 480px) {
    width: 60vw !important;
  }
`;

export const SpinWrapper = styled.div`
  padding: 14px;
  text-align: center;
`;

const styles = css`
  height: calc(100vh - 461px);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  @media screen and (max-height: 830px) {
    height: calc(100vh - 366px);
  }
`;

export const InitialMessage = styled.div`
  ${(props) => props.size === "large" && styles}

  ${MessageText} {
    background-color: #fff;
    margin-top: 24px;
    border-radius: 16px 16px 16px 0px;
  }
`;

// ========================================

/**
 * SendBox START
 */

export const SendContainer = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 199;
`;

export const Box = styled.div`
  max-width: 448px;

  width: 100%;
  padding: 12px 0;
  padding-bottom: 8px;
  gap: 6px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: ${(props) => props.theme.backgroundColor};

  :nth-child(2) {
    flex: 1;
  }

  .ant-btn {
    background-color: #0378db !important;
    border-color: #0378db !important;

    :hover {
      border-color: #0378db !important;
    }

    svg {
      color: #fff;
    }
  }

  label {
    cursor: pointer;

    .anticon {
      font-size: 30px;
      color: gray;
    }
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const Input = styled(AntInput.TextArea)`
  max-height: 200px !important;
  border: 1px solid gray;
  border-radius: 20px;

  :hover {
    border: 1px solid gray;
  }
`;

/**
 * SendBox END
 */

// ========================================

/**
 * OptionBox START
 */

export const BoxWrapper = styled.div`
  position: relative;
  bottom: 0;
  border-radius: 12px;
  background-color: ${(props) => props.theme.white};
  padding: 0;
  padding-bottom: 12px;
  height: 530px;
`;

export const OptBox = styled(Row).attrs({
  gutter: [8, 6],
})`
  width: 100%;
  height: ${props => props.more ? "127px" : "110px"};
  overflow-y: auto;
  margin: 0 !important;
  background-color: #ffffff;
  padding: 12px;

  svg {
    cursor: pointer;
  }
`;

export const Option = styled.div`
  padding: 4px 12px 4px 12px;
  border-radius: 8px;
  background-color: #dfdfdf;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  color: #482701;
  white-space: nowrap !important;
  margin-top: 2.3px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const More = styled(Option)`
  background: linear-gradient(269.14deg, #ffe83a 0.75%, #ff961b 99.27%);
`;

/**
 * OptionBox END
 */

// ========================================

/***
 * SocialBox START
 */

export const SocialBox = styled.div`
  display: flex;
  width: 100%;
`;

export const Title = styled.div`
  color: #13100F;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 5px;
`;

export const PhoneBox = styled(Space)`
  width: 100%;
  padding-top: 24px;

  .ant-space-item {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: #000;
  }

  > .ant-space-item:nth-child(2) {
    flex: 0;
  }

  .ant-divider {
    height: 30px !important;
    margin: 0 !important;
    border-inline-start: 2px solid #ecb2e9;
  }

  svg {
    width: 20px;
    height: 20px;
    padding-top: 5px;
  }

  @media screen and (max-width: 360px) {
    .ant-space-item {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 325px) {
    .ant-space-item {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 295px) {
    .ant-space-item {
      font-size: 10px;
    }
  }

  @media screen and (max-height: 800px) {
    padding-top: 12px;
  }
`;

export const SocialWrapper = styled.div`
  flex: 1;
  height: 67px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 16px;
  svg {
    width: 28px;
    height: 28px;
  }
  a {
    text-decoration: none !important;
  }
  margin: 5px;
`;

export const PhoneWrapper = styled.div`
  width: 175px;
  height: 67px;
  background: ${(props) => props.theme.dark4};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  svg {
    width: 16px;
    height: 16px;
  }
  a {
    text-decoration: none !important;
  }
  @media screen and (max-height: 800px) {
    margin: 10px;
  }
  @media screen and (max-width: 380px) {
    margin: 5px;
  }
`;

export const PhoneText = styled.p`
  color: #13100F;
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
`;

export const SocialLink = styled.a`
  margin-right: 5px;

  @media screen and (max-width: 346px) {
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const AdminAndTime = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.sender === ADMIN_LK ? "flex-start" : "flex-end"};
`;
